import { any, bool } from 'prop-types';
import { mapContains } from 'react-immutable-proptypes';

const modalType = mapContains({
	isOpen: bool.isRequired,
	data: any,
});

export default modalType;
